import React from 'react'
import RenderInBrowser from 'react-render-in-browser'

const BrowserSpecificPopover = () => (
  <div>
    <RenderInBrowser chrome only>
      <span>
          To use the caller ID feature, copy/paste
          <strong> chrome://settings/content/notifications </strong>
          into the url bar, configure your browser settings
          to allow notifications from threadcommunication, and refresh the page
      </span>
    </RenderInBrowser>
    <RenderInBrowser firefox only>
      <span>
        To use the caller ID feature, copy/paste
        <strong> about:preferences#content </strong>
        into the url bar, configure your browser settings
        to allow notifications from threadcommunication, and refresh the page
      </span>
    </RenderInBrowser>
    <RenderInBrowser opera only>
      <span>
        To use the caller ID feature, copy/paste
        <strong> opera://settings/content/notifications </strong>
        into the url bar, configure your browser settings
        to allow notifications from threadcommunication, and refresh the page
      </span>
    </RenderInBrowser>
    <RenderInBrowser safari only>
      <span>
        To use the caller ID feature, go to Safari &gt; Preferences &gt;
        Websites &gt; Notifications, configure your browser settings
        to allow notifications from threadcommunication, and refresh the page
      </span>
    </RenderInBrowser>
    <RenderInBrowser except chrome firefox opera safari>
      <span>
        To use the caller ID feature, please configure your browser settings
        to allow notifications from threadcommunication and refresh the page
      </span>
    </RenderInBrowser>
  </div>
)

export default BrowserSpecificPopover



// WEBPACK FOOTER //
// ./src/components/Account/BrowserSpecificPopover.js